"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var _crema_1 = require("../../../@crema");
var react_redux_1 = require("react-redux");
var InfoView = function () {
    var _a = (0, react_redux_1.useSelector)(function (_a) {
        var common = _a.common;
        return common;
    }), error = _a.error, loading = _a.loading, message = _a.message;
    var showMessage = function () {
        return React.createElement(_crema_1.MessageView, { variant: 'success', message: message.toString() });
    };
    var showError = function () {
        return React.createElement(_crema_1.MessageView, { variant: 'error', message: error.toString() });
    };
    return (React.createElement(React.Fragment, null,
        loading && React.createElement(_crema_1.Loader, null),
        message && showMessage(),
        error && showError()));
};
exports.default = InfoView;
//# sourceMappingURL=index.js.map